import { computed } from '@angular/core';
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';

export interface IrisDmsSidebarStateI {
  sidebarShown: boolean;
  selectedFileId: string;
  isFileEdit: boolean;
  selectedFolderId: string;
  selectedTabIndex: number;
}

export const initialState: IrisDmsSidebarStateI = {
  sidebarShown: false,
  selectedFileId: null,
  isFileEdit: false,
  selectedFolderId: null,
  selectedTabIndex: 0,
};

export const IrisDmsSidebarStore = signalStore(
  { providedIn: 'root', protectedState: false },
  withState<IrisDmsSidebarStateI>(initialState),
  withComputed(store => ({
    fileSidebarShown: computed(() => store.sidebarShown() && !!store.selectedFileId()),
    folderSidebarShown: computed(() => store.sidebarShown() && !!store.selectedFolderId()),
  })),
  withMethods(store => ({
    showFolderSidebar(folderId: string) {
      patchState(store, {
        sidebarShown: true,
        selectedFolderId: folderId,
        selectedFileId: null,
      });
    },
    showFileSidebar(fileId: string) {
      patchState(store, {
        sidebarShown: true,
        selectedFileId: fileId,
        selectedFolderId: null,
      });
    },
    showFileEditSidebar(fileId: string) {
      patchState(store, {
        sidebarShown: true,
        selectedFileId: fileId,
        isFileEdit: true,
        selectedFolderId: null,
      });
    },
    cancelFileEdit(hideSidebar = false) {
      const changes: Partial<IrisDmsSidebarStateI> = { isFileEdit: false };
      if (hideSidebar) {
        changes.sidebarShown = false;
      }
      patchState(store, changes);
    },
    selectTab(selectedTabIndex: number) {
      patchState(store, { selectedTabIndex });
    },
    hideSidebar() {
      patchState(store, initialState);
    },
  })),
);
